import { render, staticRenderFns } from "./cmp-select2.vue?vue&type=template&id=5543fa0d&"
import script from "./cmp-select2.vue?vue&type=script&lang=js&"
export * from "./cmp-select2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5543fa0d')) {
      api.createRecord('5543fa0d', component.options)
    } else {
      api.reload('5543fa0d', component.options)
    }
    module.hot.accept("./cmp-select2.vue?vue&type=template&id=5543fa0d&", function () {
      api.rerender('5543fa0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/comp/cmp-select2.vue"
export default component.exports